import { Fill, Stroke } from 'ol/style';
import Style from "ol/style/Style";
import { BaseStyle } from "../../../../lib/layers/selectable/styling/styles";
;
;
;
export class DefaultParcelStyle extends BaseStyle {
    constructor(clicked_style, hovered_style, searched_style) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        super();
        this.alt = true;
        this.name = 'default';
        this.mode = '';
        this.style_cache = {
            'SEARCHED_PARCELS': [
                new Style({
                    fill: new Fill({
                        color: (_a = searched_style === null || searched_style === void 0 ? void 0 : searched_style.fillColor) !== null && _a !== void 0 ? _a : 'rgba(60, 230, 230, 0.0)',
                    }),
                    stroke: new Stroke({
                        color: (_b = searched_style === null || searched_style === void 0 ? void 0 : searched_style.strokeColor) !== null && _b !== void 0 ? _b : 'rgba(0, 189, 255, 0.9)',
                        width: (_c = searched_style === null || searched_style === void 0 ? void 0 : searched_style.strokeWidth) !== null && _c !== void 0 ? _c : 3,
                    }),
                }),
            ],
            'HOVERED_PARCEL': [new Style({
                    fill: new Fill({
                        color: (_d = hovered_style === null || hovered_style === void 0 ? void 0 : hovered_style.fillColor) !== null && _d !== void 0 ? _d : 'rgba(93, 217, 193, 0.0)'
                    }),
                    stroke: new Stroke({
                        color: (_e = hovered_style === null || hovered_style === void 0 ? void 0 : hovered_style.strokeColor) !== null && _e !== void 0 ? _e : 'rgba(0, 189, 255, 1)',
                        width: (_f = hovered_style === null || hovered_style === void 0 ? void 0 : hovered_style.strokeWidth) !== null && _f !== void 0 ? _f : 5
                    })
                }),
            ],
            'CLICKED_PARCEL': [
                new Style({
                    fill: new Fill({
                        color: (_g = clicked_style === null || clicked_style === void 0 ? void 0 : clicked_style.fillColor) !== null && _g !== void 0 ? _g : 'rgba(60, 145, 230, 0.0)',
                    }),
                    stroke: new Stroke({
                        color: (_h = clicked_style === null || clicked_style === void 0 ? void 0 : clicked_style.strokeColor) !== null && _h !== void 0 ? _h : 'rgba(255, 165, 0, 1)',
                        width: (_j = clicked_style === null || clicked_style === void 0 ? void 0 : clicked_style.strokeWidth) !== null && _j !== void 0 ? _j : 4,
                    }),
                    zIndex: 999999
                }),
            ],
            'Included': [
                new Style({
                    fill: new Fill({
                        color: 'rgba(93, 217, 193, 0.0)',
                    }),
                    stroke: new Stroke({
                        color: '#008000',
                        width: 4,
                    }),
                }),
            ],
            'Excluded': [
                new Style({
                    fill: new Fill({
                        color: 'rgba(60, 230, 230, 0.0)',
                    }),
                    stroke: new Stroke({
                        color: '#ff0000',
                        width: 2,
                    }),
                }),
            ],
            'Selected': [
                new Style({
                    fill: new Fill({
                        color: 'rgba(60, 145, 230, 0.0)',
                    }),
                    stroke: new Stroke({
                        color: '#0000ff',
                        width: 4,
                    }),
                }),
            ],
        };
    }
    style_function(identifier, clicked, hovered) {
        return (feature) => {
            let c = clicked();
            if (this.mode == 'included') {
                return this.style_cache.Included;
            }
            ;
            if (this.mode == 'excluded') {
                return this.style_cache.Excluded;
            }
            ;
            if (this.mode == 'selected') {
                return this.style_cache.Selected;
            }
            ;
            if (Array.isArray(c) && c.includes(feature.get(identifier)))
                return this.style_cache.CLICKED_PARCEL;
            if (feature.get(identifier) === c)
                return this.style_cache.CLICKED_PARCEL;
            if (feature.get(identifier) === hovered())
                return this.style_cache.HOVERED_PARCEL;
            return this.style_cache.SEARCHED_PARCELS;
        };
    }
}
